import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Profile from './pages/Profile';
import Analytics from './pages/Analytics';

function App() {
  const [isAuth, setAuth] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      // Optional: Verify token expiry here
      setAuth(true);
    }
    setLoading(false);
  }, []);

  const logout = () => {
    localStorage.clear();
    setAuth(false);
    // Force redirect to home or login handled by protected route or user action
    window.location.href = '/login';
  };

  if (loading) return null; // or a loading spinner

  return (
    <ThemeProvider>
      <Router>
        <div className="min-h-screen transition-colors duration-300">
          <Navbar isAuth={isAuth} logout={logout} />
          <main>
            <Routes>
              <Route path="/" element={<Home isAuth={isAuth} logout={logout} />} />
              <Route
                path="/login"
                element={!isAuth ? <Login setAuth={setAuth} /> : <Navigate to="/" />}
              />
              <Route
                path="/signup"
                element={!isAuth ? <Signup /> : <Navigate to="/" />}
              />
              <Route
                path="/profile"
                element={isAuth ? <Profile /> : <Navigate to="/login" />}
              />
              <Route
                path="/analytics"
                element={isAuth ? <Analytics /> : <Navigate to="/login" />}
              />
            </Routes>
          </main>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
